import { push } from "react-router-redux";

import { Action } from "../../index";
import API from "../../../vendor/api";

import { setUser } from "../auth/auth";

/**
 * Actions
 */

// Request code
const CODE_REQUEST = "meumedico/appAuth/CODE_REQUEST";
function codeRequest(phone: string) {
    return {
        type: CODE_REQUEST,
        payload: {
            phone
        }
    };
}

const CODE_SUCCESS = "meumedico/appAuth/CODE_SUCCESS";
function codeSuccess() {
    return {
        type: CODE_SUCCESS
    };
}

export function fetchForCode(phone: string) {
    return function (dispatch: any) {
        dispatch(codeRequest(phone));

        API.requestLoginCode(phone).then(r => {
            dispatch(codeSuccess());
            dispatch(changeLoginStep("askForCode"));
        })
    };
}

// Login
const LOGIN_REQUEST = "meumedico/appAuth/LOGIN_REQUEST";
function loginRequest() {
    return {
        type: LOGIN_REQUEST
    };
}

const LOGIN_SUCCESS = "meumedico/appAuth/LOGIN_SUCCESS";
function loginSuccess(user: API.User) {
    return {
        type: LOGIN_SUCCESS,
        payload: {
            user
        }
    };
}

const LOGIN_FAILURE = "meumedico/appAuth/LOGIN_FAILURE";
function loginFailure(error: string) {
    return {
        type: LOGIN_FAILURE,
        payload: {
            error
        }
    };
}

export function login(phone: string, code: string) {
    return function (dispatch: any) {
        dispatch(loginRequest());

        API.loginWithCode(phone, code).then(user => {
            dispatch(setUser(user));
            dispatch(loginSuccess(user));
            dispatch(push("/"));
        }).catch(error => {
            dispatch(loginFailure(error));
        });
    };
}

// Change login step
const CHANGE_LOGIN_STEP = "meumedico/appAuth/CHANGE_LOGIN_STEP";
function changeLoginStep(step: string) {
    return {
        type: CHANGE_LOGIN_STEP,
        payload: {
            step
        }
    };
}


// Edit profile
export const EDIT_PROFILE_REQUEST = "meumedico/appAuth/EDIT_PROFILE_REQUEST";
export function editProfileRequest() {
    return {
        type: EDIT_PROFILE_REQUEST
    };
}

export const EDIT_PROFILE_SUCCESS = "meumedico/appAuth/EDIT_PROFILE_SUCCESS";
export function editProfileSuccess(userDefailts: API.UserDetails) {
    return {
        type: EDIT_PROFILE_SUCCESS,
        payload: {
            userDefailts
        }
    };
}

export const EDIT_PROFILE_FAILURE = "meumedico/appAuth/EDIT_PROFILE_FAILURE";
export function editProfileFailure(error: string) {
    return {
        type: EDIT_PROFILE_FAILURE,
        payload: {
            error
        }
    };
}

export function editProfile(name: string, email: string, gender: API.Gender) {
    return function (dispatch: any) {
        dispatch(editProfileRequest());

        const userDetails = {
            name,
            email,
            gender
        }

        // API.setAvatar();

        API.setDetails(userDetails).then(res => {
            dispatch(editProfileSuccess(userDetails));
        }).catch(error => {
            dispatch(editProfileFailure(error));
        });
    };
}

// Fetch current user

export function fetchCurrentUser() {
    return function (dispatch: any) {
        API.currentUser().then(user => {
            dispatch(setUser(user));
        }).catch(error => {
            
        });
    }
}


// Reducer
export interface AppAuthState {
    logged: boolean;
    isLoggingIn: boolean;
    isInvalid: boolean;
    isSendingCode: boolean;
    loginError: string;
    loginStep: string;
    loginData: {
        phone?: string;
        code?: string;
    };
}

export interface LoginPayload {
    json: any;
}

export interface ChangeLoginStepPayload {
    step: string;
}

export interface CodeRequestPayload {
    phone: string;
}

export interface EditProfileSuccessPayload {
    userDefailts: API.UserDetails;
}

export interface CodeFailurePayload {
    error: string;
}

const INITIAL_STATE: AppAuthState = {
    logged: false,
    isLoggingIn: false,
    isInvalid: false,
    isSendingCode: false,
    loginError: "",
    loginStep: "AskForPhone",
    loginData: {}
};

export default function reducer(state: AppAuthState = INITIAL_STATE, action: Action<CodeRequestPayload | ChangeLoginStepPayload | LoginPayload | CodeFailurePayload>) {
    switch (action.type) {
        case CODE_REQUEST:
            return Object.assign({}, state, {
                isSendingCode: true,
                loginData: Object.assign({}, state.loginData, {
                    phone: (action.payload as CodeRequestPayload).phone
                })
            });
        case CODE_SUCCESS:
            return Object.assign({}, state, {
                isSendingCode: false
            });
        case LOGIN_FAILURE:
            return Object.assign({}, state, {
                isLoggingIn: false,
                loginError: (action.payload as CodeFailurePayload).error
            });
        case LOGIN_REQUEST:
            return Object.assign({}, state, {
                isLoggingIn: true
            });
        case LOGIN_SUCCESS:
            return Object.assign({}, state, {
                isLoggingIn: false,
                logged: true
            });
        case CHANGE_LOGIN_STEP:
            let step = (action.payload as ChangeLoginStepPayload).step;
            if (["askForPhone", "askForCode"].indexOf(step) === -1) {
                return state;
            }
            return Object.assign({}, state, {
                loginStep: step
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/modules/appAuth/appAuth.ts